import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from "@mui/material";
import { userStatus } from "../../utils/enums";
const statusColorMap = {
    [userStatus.Pending]: "warning",
    [userStatus.Active]: "success",
    [userStatus.Deactivated]: "error",
    [userStatus.Invited]: "info",
};
const StatusPill = ({ status }) => (_jsx(Chip, { label: status, color: statusColorMap[status], variant: "outlined", sx: { fontWeight: 600, borderRadius: "16px", px: 1.5 } }));
export default StatusPill;
